import { render } from "./ArtifactsPane.vue?vue&type=template&id=a45e4c0e"
import script from "./ArtifactsPane.vue?vue&type=script&lang=js"
export * from "./ArtifactsPane.vue?vue&type=script&lang=js"

import "./ArtifactsPane.vue?vue&type=style&index=0&id=a45e4c0e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__